import "../sass/pages/_gallery.scss";
import GoToTop from "../utils/GoToTop";
export default function Gallery() {
  return (
    <div id="parent">
      <main class="gallery">
        <h1>Galeri</h1>
        <ul class="gallery__list">
          <li key="image-1">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo1.jpeg"
                alt="Image 1"
              />
            </figure>
          </li>
          <li key="image-6">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo6.jpeg"
                alt="Image 6"
              />
            </figure>
          </li>
          <li key="image-7">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo7.jpeg"
                alt="Image 7"
              />
            </figure>
          </li>
          <li key="image-8">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo8.jpeg"
                alt="Image 8"
              />
            </figure>
          </li>
          <li key="image-9">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo9.jpeg"
                alt="Image 9"
              />
            </figure>
          </li>
          <li key="image-10">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo10.jpeg"
                alt="Image 10"
              />
            </figure>
          </li>
          <li key="image-11">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo11.jpeg"
                alt="Image 11"
              />
            </figure>
          </li>
          <li key="image-12">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo12.jpeg"
                alt="Image 12"
              />
            </figure>
          </li>
          <li key="image-13">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo13.jpeg"
                alt="Image 13"
              />
            </figure>
          </li>
          <li key="image-14">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo14.jpeg"
                alt="Image 14"
              />
            </figure>
          </li>
          <li key="image-15">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo15.jpeg"
                alt="Image 15"
              />
            </figure>
          </li>
          <li key="image-16">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo16.jpeg"
                alt="Image 16"
              />
            </figure>
          </li>
          <li key="image-17">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo17.jpeg"
                alt="Image 17"
              />
            </figure>
          </li>
          <li key="image-18">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo18.jpeg"
                alt="Image 18"
              />
            </figure>
          </li>
          <li key="image-19">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo19.jpeg"
                alt="Image 19"
              />
            </figure>
          </li>
          <li key="image-20">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo20.jpeg"
                alt="Image 20"
              />
            </figure>
          </li>
          <li key="image-21">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo21.jpeg"
                alt="Image 21"
              />
            </figure>
          </li>
          <li key="image-22">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo22.jpeg"
                alt="Image 22"
              />
            </figure>
          </li>
          <li key="image-23">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo23.jpeg"
                alt="Image 23"
              />
            </figure>
          </li>
          <li key="image-24">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo24.jpeg"
                alt="Image 24"
              />
            </figure>
          </li>
          <li key="image-25">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo25.jpeg"
                alt="Image 25"
              />
            </figure>
          </li>
          <li key="image-26">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo26.jpeg"
                alt="Image 26"
              />
            </figure>
          </li>
          <li key="image-27">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo27.jpeg"
                alt="Image 27"
              />
            </figure>
          </li>
          <li key="image-28">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo28.jpeg"
                alt="Image 28"
              />
            </figure>
          </li>
          <li key="image-29">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo29.jpeg"
                alt="Image 29"
              />
            </figure>
          </li>
          <li key="image-30">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo30.jpeg"
                alt="Image 30"
              />
            </figure>
          </li>
          <li key="image-31">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo31.jpeg"
                alt="Image 31"
              />
            </figure>
          </li>
          <li key="image-32">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo32.jpeg"
                alt="Image 32"
              />
            </figure>
          </li>
          <li key="image-33">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo33.jpeg"
                alt="Image 33"
              />
            </figure>
          </li>
          <li key="image-34">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo34.jpeg"
                alt="Image 34"
              />
            </figure>
          </li>
          <li key="image-35">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo35.jpeg"
                alt="Image 35"
              />
            </figure>
          </li>
          <li key="image-36">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo36.jpeg"
                alt="Image 36"
              />
            </figure>
          </li>
          <li key="image-37">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo37.jpeg"
                alt="Image 37"
              />
            </figure>
          </li>
          <li key="image-38">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo38.jpeg"
                alt="Image 38"
              />
            </figure>
          </li>
          <li key="image-39">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo39.jpeg"
                alt="Image 39"
              />
            </figure>
          </li>
          <li key="image-40">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo40.jpeg"
                alt="Image 40"
              />
            </figure>
          </li>
          <li key="image-41">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo41.jpeg"
                alt="Image 41"
              />
            </figure>
          </li>
          <li key="image-42">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo42.jpeg"
                alt="Image 42"
              />
            </figure>
          </li>
          <li key="image-43">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo43.jpeg"
                alt="Image 43"
              />
            </figure>
          </li>
          <li key="image-44">
            <figure>
              <img
                src="https://raw.githubusercontent.com/RealCodeMate/SoydanTarim/main/soydantarim/src/assets/galleryImg/photo44.jpeg"
                alt="Image 44"
              />
            </figure>
          </li>
        </ul>
      </main>
      <GoToTop />
    </div>
  );
}
